const formatNum = (num, minDecimal = 2, maxDecimal = minDecimal) => {
  if (num === null) {
    return '';
  }
  return num.toLocaleString(undefined, {
    minimumFractionDigits: minDecimal,
    maximumFractionDigits: maxDecimal,
  });
};

export default formatNum;
